module.exports = __webpack_public_path__ + "static/media/fsc9.81292a31.svg";